import api from "../services/api";

export const fetchPaymentProofs = async (page = 1, size = 10) => {
  try {
    const response = await api.get(
      `/transaction-management/payments/all-payments-proofs?page=${page}&size=${size}`
    );
    

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to fetch payment proofs" };
  }
};

export const updatePaymentProofStatus = async (proofId, status) => {
  try {
    const response = await api.put(`/transaction-management/payments/update/${proofId}`, {
      status, 
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    return { success: false, error: error.message || "Failed to update payment proof status" };
  }
};
